import { createFileRoute } from "@tanstack/react-router";

import { DataDictionaryDashboard } from "../tools/dashboards/DataDictionaryDashboard";

function DataDictionaryRoute() {
  return <DataDictionaryDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/data-dictionary")({
  component: DataDictionaryRoute,
});
